export default "__VITE_ASSET__BXXtqS7P__"